import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

import { toggleSidebar as toggle } from '../redux/sidebar/sidebarReducer';
import { useSidebarData } from '../hooks/useSidebarData';
import SidebarItem from './SidebarItem';
import Icon from '../icons/Icon';
import { ICONS } from '../icons';
import IsGranted from '../components/is-granted/IsGranted';
import Contact from '../contact/Contact';

import './Sidebar.scss';

const Sidebar = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const sidebarData = useSidebarData();
  const slim = useSelector((state) => state.sidebar.slim);

  const toggleSidebar = useCallback(() => {
    dispatch(toggle());
  }, [dispatch]);

  return (
    <aside className={clsx('main-sidebar', slim && '_slim')}>
      <Link to='/projects' className='logo'>
        <Icon icon={ICONS.Logo} className='project-logo' />
        <Icon icon={ICONS.Factive} className='project-name' />
      </Link>

      <i className='sidebar-toggle _slim' onClick={toggleSidebar} role='presentation'>
        <Icon icon={ICONS.CaretUp} className='icon' />
      </i>

      <nav className='sidebar-nav'>
        <ul className='sidebar-menu'>
          {sidebarData.map(({ label, icon, url, isStrokeIcon, selectedRoutes, permissions, disabled }) => (
            <IsGranted key={label} permissions={permissions}>
              <SidebarItem
                label={label}
                icon={icon}
                url={url}
                pathname={pathname}
                isStrokeIcon={isStrokeIcon}
                selectedRoutes={selectedRoutes}
                disabled={disabled}
              />
            </IsGranted>
          ))}
        </ul>
      </nav>

      <div className='sidebar-footer'>
        <Contact />
      </div>
    </aside>
  );
};

export default memo(Sidebar);
